export async function exchangeViewerPassword(password, { fetcher = fetch } = {}) {
  const response = await fetcher('/api/auth/viewer-login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  })
  const payload = await response.json().catch(() => ({}))
  if (!response.ok || !payload.customToken) throw new Error('비밀번호가 올바르지 않습니다.')
  return payload.customToken
}
